/*
 * @Author: cc
 * @Date: 2019-12-08 19:24:26
 * @LastEditTime: 2021-05-24 12:59:50
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\iWo\iWoPreview\newsPreview.js
 * @Description: iwo查看页
 */

'use strict';
angular.module('iWoPreviewModule', ['trsPreviewHeightModule', 'trsPreviewContentModule']).controller('iWoPreviewCtrl', [
    '$scope',
    '$compile',
    '$element',
    '$stateParams',
    '$q',
    '$sce',
    '$window',
    '$state',
    'editIsLock',
    'trsHttpService',
    'editcenterRightsService',
    'modalDialog',
    'trsPrintService',
    'localStorageService',
    'newMediaService',
    'editingCenterService',
    'ueditorService',
    'myManuscriptService',
    function(
        $scope,
        $compile,
        $element,
        $stateParams,
        $q,
        $sce,
        $window,
        $state,
        editIsLock,
        trsHttpService,
        editcenterRightsService,
        modalDialog,
        trsPrintService,
        localStorageService,
        newMediaService,
        editingCenterService,
        ueditorService,
        myManuscriptService
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.params = {
                serviceid: 'mlf_myrelease',
                methodname: 'getNewsDoc',
                MetaDataId: $stateParams.iwometadataid,
                fromsearch: $stateParams.fromsearch,
            };
            $scope.status = {
                trench: judgeByRouter(),
                departmentDocId: $state.params.departmentDocId,
                picsModelShow: true,
                onlyPreview: !$state.params.iwomodalname, // 从收藏点进来的没有该参数
                btnRights: {},
                previewBigFace: {
                    status: false,
                },
                preview: {
                    1: 'iWoNewsPreview',
                    2: 'iWoAtlasPreview',
                },
                methodname: {
                    1: 'getNewsDoc',
                    2: 'getPicsDoc',
                    3: 'getNewsDoc',
                    4: 'getLinkDoc',
                    5: '',
                    6: '',
                    7: 'getVideoDoc',
                },
                editType: {
                    1: 'iwonews',
                    2: 'iwoatlas',
                    3: 'reportsummarynews',
                    'iwo.personal': 0,
                    'iwo.received': 1,
                },
                listOpen: 1, // 相关信息打开状态
                docType: $stateParams.iwotype,
                initBtn: true,
                chnldocid: $stateParams.iwochnldocid,
                authorInfo: true, // true显示作者信息 false显示编辑信息
                types: [],
                metadataids: [],
                chnldocids: [],
            };
            $scope.data = {
                item: '',
                copyDarft: '',
                METADATAID: $stateParams.iwometadataid,
                keywords: [],
                arrVideos: [],
                fusionRouter: {
                    // 融合编辑器路由
                    '1': 'fusionnews',
                    '2': 'fusionatlas',
                    '4': 'fusionlinkdoc',
                    '5': 'fusionactivity',
                    '6': 'fusiontopic',
                    '7': 'fusionvideo',
                    '8': 'fusionlive',
                },
            };
        }

        /**
         * [judgeByRouter description]根据路由判断稿库类型
         * @return  {[type]}  [return description]
         */
        function judgeByRouter(){
            if ($state.params.fromType && $state.params.fromType === 'departmentmanuscript'){
                return 'department';
            } else if ($state.params.iwomodalname && $state.params.iwomodalname === 'iwo.docrecord'){
                return 'docrecord';
            } else if ($state.params.iwomodalname && $state.params.iwomodalname.includes('personal')){
                return 'personal';
            } else if ($state.params.iwomodalname && $state.params.iwomodalname.includes('received')){
                return 'received';
            } else {
                return 'personal';
            }
        }

        /**
         * [loadDirective description]动态加载指令
         * @return {[type]} [description]
         */
        function loadDirective() {
            var htmlContent = '<div adjustsize class="padding20" trs-play-audio-video  ng-bind-html="data.htmlContent|trsSceHtmlContent">';
            var videoContent = '<div trs-upload-for-xj-video-draft list="data.item" preview="true"></div>';
            newMediaService.previewLoadDirective($element, $compile, $scope, htmlContent, videoContent);
        }

        /**
         * [getUeditorCss description] 加载编辑器中的相关样式
         * @return {[type]} [description]
         */
        // function getUeditorCss() {
        //     $('.lazyload').remove();
        //     LazyLoad.css('./lib/ueditor2/themes/iframe.css');
        // }

        /**
         * [initData description]初始化数据,$statparam.type区分稿件类型,1是新闻稿,2是图集稿
         * @return {[type]} [description]
         */
        function initData() {
            if ($stateParams.mlftype == '9') {
                $scope.params = {
                    Method: 'articleInfo',
                    ID: $stateParams.iwometadataid,
                    methodname: 'queryArticles',
                    serviceid: 'mlf_ugc',
                };
            } else if ($stateParams.iwomodalname === 'iwo.collect') {
                $scope.params = {
                    CollectId: $stateParams.iwodoccollectrelid,
                    MetaDataId: $stateParams.iwometadataid,
                    methodname: 'queryCollectDoc',
                    serviceid: 'mlf_myrelease',
                };
            } else {
                $scope.params.methodname = $scope.status.methodname[$stateParams.iwotype];
                copyNewsDarft();
            }
            dealRights();
            requestData().then(function(data) {
                if (!!$stateParams.iwometadataid) {
                    // 
                }
                editcenterRightsService.operManuscriptRight($scope.data.item).then(function(rights) {
                    $scope.status.rights = rights; // 用于判断是否可编辑
                });
                loadDirective();
                loadVersionTimePanel();
            });
        }

        /**
         * [dealRights description] 处理权限
         * @return  {[type]}  [return description]
         */
        function dealRights() {
            if ($scope.status.onlyPreview) {
                return;
            }
            if (!$stateParams.departmentDocId) {
                editcenterRightsService.initIwoListBtn($stateParams.iwomodalname).then(function(data) {
                    $scope.status.btnRights = data;
                });
            } else {
                getDepartDocAuthority();
            }
            // 获取查看痕迹按钮权限
            editcenterRightsService.initIwoListBtn('iwo.trace').then(function(data) {
                $scope.status.bigFaceRights = !!data['iwo.trace.chakan'] ? 'true' : 'false';
            });
        }

        /**
         * [getDepartDocAuthority description]获取部门稿库权限
         * @return  {[type]}  [return description]
         */
        function getDepartDocAuthority() {
            var params = {
                serviceid: 'mlf_metadataright',
                methodname: 'queryOperkeyOfDeptmentalDoc',
                DepartmentalDocId: $stateParams.departmentDocId,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                for (var i = 0; i < data.length; i++) {
                    $scope.status.btnRights[data[i]] = true;
                }
            });
        }

        /**
         * [getBindingMediaIds description] 获取绑定的渠道的相关id
         * @param {[type]} [iwometadataid] [description] iwo稿件id
         * @return {[type]} [description]
         */
        function getBindingMediaIds(iwometadataid) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_fusioncreate',
                methodname: 'queryFuseMappings',
                sourceDocId: iwometadataid,
                mediaTypes: '',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                defer.resolve(data);
            });
            return defer.promise;
        }

        /**
         * [copyNewsDarft description]
         * @return  {[type]}  [return description]
         */
        function copyNewsDarft() {
            var copyParams = {
                serviceid: 'mlf_releasesource',
                methodname: 'queryCopyAndBuildDocs',
                MetaDataId: $stateParams.iwometadataid, // news
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), copyParams, 'get').then(function(data) {
                $scope.data.copyDarft = data;
            });
        }

        /**
         * [requestData description]
         * @return  {[type]}  [return description]
         */
        function requestData() {
            // iwo
            var defered = $q.defer();
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                if ($stateParams.mlftype == '9') {
                    $scope.data.item = data.data[0].article;
                    $scope.data.item.CRTIME = data.data[0].article.crtime;
                    $scope.data.item.TITLE = data.data[0].article.articleTitle;
                    $scope.data.htmlContent = $sce.trustAsHtml(data.data[0].article.articleHtmlCon);
                } else {
                    $scope.data.item = data;
                    $scope.data.item.ABSTRACT = angular.isDefined($scope.data.item.ABSTRACT) ? $scope.data.item.ABSTRACT.replace(/\n/g, '<br/>') : '';
                    $scope.data.item.CONTENT = $sce.trustAsHtml($scope.data.item.CONTENT);
                    $scope.data.htmlContent = $sce.trustAsHtml(data.HTMLCONTENT);
                    if (data.KEYWORDS) {
                        $scope.data.keywords = data.KEYWORDS.split(';');
                    }
                    document.title = data.TITLE;
                    // $scope.data.selectedArray = [
                    //     {
                    //         TITLE: $scope.data.item.TITLE,
                    //         CHNLDOCID: $stateParams.iwochnldocid,
                    //         METADATAID: $stateParams.iwometadataid,
                    //     },
                    // ];
                }
                $scope.data.item.HTMLCONTENT = ueditorService.fixAppHtmlTag($scope.data.item.HTMLCONTENT);
                $scope.data.htmlContent = ueditorService.fixAppHtmlTag($scope.data.htmlContent);
                $scope.list = angular.copy($scope.data.item); // 复制一份list为了与编辑页一致，方便调用通用方法
                myManuscriptService.getDraftRelatedInfo($scope);
                defered.resolve(data);
            });
            return defered.promise;
        }

        /**
         * [pageTurning description] 翻页 上一篇/下一篇
         * @param {int} direction [description]
         * @return {[type]} [description]
         */
        $scope.pageTurning = function(direction) {
            var pageTurningData;
            pageTurningData = JSON.parse(localStorageService.get('fusionPreview'));
            var metadataid = $stateParams.iwometadataid;
            var chnldocid = $stateParams.iwochnldocid;
            var toPageData;
            for (var i = 0; i < pageTurningData.length; i++) {
                if (
                    pageTurningData[i].METADATAID === metadataid ||
                    pageTurningData[i].DOCID === metadataid ||
                    pageTurningData[i].MLFID === metadataid ||
                    pageTurningData[i].CHNLDOCID === chnldocid
                ) {
                    toPageData = pageTurningData[i + direction];
                    break;
                }
            }
            if (!toPageData) {
                var directionTxt = direction === 1 ? '下' : '上';
                modalDialog.alertType('没有' + directionTxt + '一篇了！', '', 'warning', false);
                return;
            }
            // 此处判断稿件类型，由于广电广电文稿、串联单不属于融合，所以调用不同的详情页
            if (toPageData.DOCTYPEID == '9' || toPageData.DOCTYPE == '9') {
                broadcastingAndTVGostate(
                    toPageData.DOCTYPEID,
                    toPageData.METADATAID || toPageData.DOCID,
                    toPageData.CHNLDOCID,
                    'iwomanuscriptpreview'
                );
            } else if (toPageData.DOCTYPEID == '11' || toPageData.DOCTYPE == '11') {
                broadcastingAndTVGostate(
                    toPageData.DOCTYPEID,
                    toPageData.METADATAID || toPageData.DOCID,
                    toPageData.CHNLDOCID,
                    'iwoseriessheetpreview'
                );
            } else {
                if ($stateParams.iwomodalname === 'iwo.collect') {
                    fusionGostate(toPageData.DOCTYPEID, toPageData.MLFID, toPageData.CHNLDOCID, toPageData.MLFTYPE, toPageData.DOCCOLLECTRELID);
                } else if ($stateParams.iwomodalname === 'iwo.waste') {
                    fusionGostate(toPageData.DOCTYPEID, toPageData.DOCID, toPageData.CHNLDOCID);
                } else {
                    fusionGostate(toPageData.DOCTYPEID, toPageData.METADATAID, toPageData.CHNLDOCID, '', '', toPageData.DEPARTDOCRELID);
                }
            }
        };

        /**
         * [broadcastingAndTVGostate description] 广电广电文稿预览页跳转]
         * @param   {[type]}  doctype        [doctype description]
         * @param   {[type]}  iwometadataid  [iwometadataid description]
         * @param   {[type]}  iwochnldocid   [iwochnldocid description]
         * @param   {[type]}  channel        [channel description]
         * @return  {[type]}                 [return description]
         */
        function broadcastingAndTVGostate(doctype, iwometadataid, iwochnldocid, channel) {
            var url = channel,
                routerParams = {
                    iwotype: doctype,
                    iwomodalname: $stateParams.iwomodalname,
                    wzplatform: 0,
                    wztypeid: doctype,
                    appplatform: 0,
                    newspapertype: 2,
                    iwometadataid: iwometadataid,
                    iwochnldocid: iwochnldocid,
                    iwoplatform: $stateParams.iwoplatform,
                };
            routerParams.appdoctype = doctype;
            $state.go(url, routerParams, {
                reload: true
            }); // new
        }

        /**
         * [fusionGostate description] 融合采编预览页跳转
         * @param   {[type]}  doctype         [doctype description]
         * @param   {[type]}  iwometadataid   [iwometadataid description]
         * @param   {[type]}  iwochnldocid    [iwochnldocid description]
         * @param   {[type]}  mlftype         [mlftype description]
         * @param   {[type]}  collectid       [collectid description]
         * @param   {[type]}  departdocrelid  [departdocrelid description]
         * @return  {[type]}                  [return description]
         */
        function fusionGostate(doctype, iwometadataid, iwochnldocid, mlftype, collectid, departdocrelid) {
            mlftype = !mlftype ? '' : mlftype;
            collectid = !collectid ? '' : collectid;
            var routerParams = {
                iwotype: doctype,
                iwomodalname: $stateParams.iwomodalname,
                wzplatform: 0,
                wztypeid: doctype,
                appplatform: 0,
                newspapertype: 2,
                iwometadataid: iwometadataid,
                iwochnldocid: iwochnldocid,
                mlftype: mlftype, // 是否来自资源中心
                iwodoccollectrelid: collectid,
                departdocrelid: departdocrelid,
                iwoplatform: $stateParams.iwoplatform,
            };
            routerParams.appdoctype = doctype;
            if (mlftype == 0 || !mlftype) {
                // iwo
                getBindingMediaIds(iwometadataid).then(function(bingdingData) {
                    angular.forEach(bingdingData, function(value, key) {
                        if (value.MEDIATYPE == '1') {
                            routerParams.appsiteid = value.SITEID;
                            routerParams.appchannelid = value.CHANNELID;
                            routerParams.appchnldocid = value.CHNLDOCID;
                            routerParams.appmetadataid = value.VIRTUALDOCID;
                        } else if (value.MEDIATYPE == '2') {
                            routerParams.wzsiteid = value.SITEID;
                            routerParams.wzchannelid = value.CHANNELID;
                            routerParams.wzchnldocid = value.CHNLDOCID;
                            routerParams.wzmetadataid = value.VIRTUALDOCID;
                        } else if (value.MEDIATYPE == '3') {
                            routerParams.paperid = value.CHANNELID; // 预览页与编辑页参数不同
                            routerParams.bzmetadata = value.VIRTUALDOCID; // 预览页与编辑页参数不同
                        }
                    });
                    $state.go($state.current.name, routerParams, {
                        reload: true
                    }); // new
                });
            } else {
                $state.go($state.current.name, routerParams, {
                    reload: true
                }); // new
            }
        }

        /**
         * [edit description]跳转到编辑
         * @return {[type]} [description]null
         */
        // $scope.edit = function() {
        //     if ($stateParams.fromType && $stateParams.fromType === 'departmentmanuscript') {
        //         isLockEdit($scope.data.item);
        //     } else {
        //         edit();
        //     }
        // };

        /**
         * [isLockEdit description]编辑前请求解锁
         *
         * @param   {[type]}  item  [item description]稿件对象
         *
         * @return  {[type]}        [return description]
         */
        function isLockEdit(item) {
            var params = {
                serviceid: 'mlf_metadata',
                methodname: 'checkLock',
                MetaDataId: item.METADATAID,
                MediaType: -1,
                DepartmentalDocId: $state.params.departmentDocId,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                if (data.ISLOCK == 'false') {
                    edit();
                } else {
                    editIsLock.checkUnlockPermissions(item, data).then(function() {
                        edit();
                    });
                }
            });
        }

        /**
         * [edit description]
         * @return  {[type]}  [return description]
         */
        // function edit() {
        //     if ($stateParams.iwomodalname === 'iwo.collect' || $stateParams.iwotype === '3') {
        //         $state.go(
        //             $scope.status.editType[$stateParams.iwotype],
        //             {
        //                 iwochnldocid: $stateParams.iwochnldocid,
        //                 iwometadataid: $stateParams.iwometadataid,
        //                 iwoplatform: $scope.status.editType[$stateParams.iwomodalname],
        //             },
        //             {
        //                 reload: true,
        //             }
        //         );
        //     } else {
        //         var routerParams = {
        //             iwometadataid: $stateParams.iwometadataid,
        //             iwochnldocid: $stateParams.iwochnldocid,
        //             iwoplatform: $state.params.iwoplatform,
        //             wzmetadataid: $stateParams.wzmetadataid,
        //             wzchnldocid: $stateParams.wzchnldocid,
        //             wzchannelid: $stateParams.wzchannelid,
        //             wzsiteid: $stateParams.wzsiteid,
        //             wzplatform: 0,
        //             appmetadataid: $stateParams.appmetadataid,
        //             appchnldocid: $stateParams.appchnldocid,
        //             appchannelid: $stateParams.appchannelid,
        //             appsiteid: $stateParams.appsiteid,
        //             appplatform: 0,
        //             newspapertype: 2,
        //             paperid: $stateParams.paperid,
        //             papermetadataid: $stateParams.bzmetadata,
        //             wxplatform: 0,
        //             wxchannelid: $stateParams.wxchannelid,
        //             wxchnldocid: $stateParams.wxchnldocid,
        //             wxmetadataid: $stateParams.wxmetadataid,
        //             wbmetadataid: $stateParams.wbmetadataid,
        //             departdocrelid: $stateParams.departdocrelid,
        //             douyinarticleid: $stateParams.douyinarticleid,
        //             baijiahaoarticleid: $stateParams.baijiahaoarticleid,
        //             qiehaoarticleid: $stateParams.qiehaoarticleid,
        //         };
        //         if ($stateParams.fromType === 'departmentmanuscript') {
        //             routerParams.fromType = 'departmentmanuscript';
        //             routerParams.departmentaldocid = $stateParams.departmentDocId;
        //         }
        //         $state.go($scope.data.fusionRouter[$stateParams.iwotype], routerParams, { reload: true });
        //     }
        // }

        // 创作轴
        $scope.creationAxis = function() {
            if (!$state.params.mlftype || $state.params.mlftype == '0') {
                addToCreationFromWCM($stateParams.iwometadataid);
            } else if ($state.params.mlftype == '1') {
                addToCreationFromBD($stateParams.iwometadataid, $scope.data.item.CHANNELNAME, $scope.data.item.INDEXNAME);
            } else if ($state.params.mlftype == '9') {
                ugcAddToCreation($stateParams.iwometadataid);
            }
        };

        /**
         * [ugcAddToCreation description] ugc稿件加入创作轴
         * @param   {[type]}  id  [id description]
         * @return  {[type]}      [return description]
         */
        function ugcAddToCreation(id) {
            var params = {
                serviceid: 'mlf_ugc',
                methodname: 'createCreations',
                Method: 'articleInfo',
                id: id,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('添加成功', '', 'success', false);
                $window.document.getSelection().collapse($window.document, 1);
            });
        }

        /**
         * [addToCreationFromWCM description]从WCM加入到创作轴
         *
         * @param   {[type]}  metadataid  [metadataid description]
         *
         * @return  {[type]}              [return description]
         */
        function addToCreationFromWCM(metadataid) {
            var params = {
                serviceid: 'mlf_releasesource',
                methodname: 'addPersonalMaterialOfTxt',
                PersonalMaterialId: 0,
                metadataid: metadataid,
                MediaType: '-1',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('添加成功', '', 'success', false);
                $window.document.getSelection().collapse($window.document, 1);
            });
        }

        /**
         * [addToCreationFromBD description] 从大数据加入到创作轴
         * @param   {[type]}  guid         [guid description]
         * @param   {[type]}  channelName  [channelName description]
         * @param   {[type]}  indexName    [indexName description]
         * @return  {[type]}               [return description]
         */
        function addToCreationFromBD(guid, channelName, indexName) {
            var params = {
                typeid: 'zyzx',
                serviceid: 'mlf_bigdataexchange',
                methodname: 'batchPersonalMaterial',
                guid: guid,
                channelName: $scope.data.item.ISROBOT == 'true' ? '' : channelName,
            };
            if (channelName === 'tpg') {
                params.nodeId = $scope.data.item.NODEID;
                params.PICIDS = $scope.data.item.PICID;
            } else {
                params.indexname = indexName;
                params.ISROBOT = $scope.data.item.ISROBOT == 'true' ? true : null;
            }
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('添加成功', '', 'success', false);
                $window.document.getSelection().collapse($window.document, 1);
            });
        }

        /**
         * [printBtn description]打印
         * @return  {[type]}  [return description]
         */
        $scope.printBtn = function() {
            requestPrintVersion($stateParams.iwometadataid).then(function(data) {
                requestPrintData(data);
            });
        };

        /**
         * [requestPrintVersion description]打印
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        function requestPrintVersion(item) {
            var deferred = $q.defer();
            trsHttpService
                .httpServer(
                    trsHttpService.getWCMRootUrl(),
                    {
                        serviceid: 'mlf_metadatalog',
                        methodname: 'query',
                        MetaDataId: item,
                    },
                    'get'
                )
                .then(function(data) {
                    deferred.resolve(data.DATA);
                });
            return deferred.promise;
        }

        /**
         * [requestPrintData description]打印
         * @param   {[type]}  version  [version description]
         * @return  {[type]}           [return description]
         */
        function requestPrintData(version) {
            var params = {
                serviceid: 'mlf_myrelease',
                methodname: $scope.status.methodname[$stateParams.iwotype],
                MetaDataId: $stateParams.iwometadataid,
            };
            $scope.data.printResult = [];
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                var result = data;
                data.VERSION = version;
                data.HANGCOUNT = Math.ceil(data.DOCWORDSCOUNT / 27);
                $scope.data.printResult.push(result);
                trsPrintService.trsIwoPrintDocument($scope.data.printResult);
            });
        }

        /**
         * [bigFace description] 查看痕迹
         * @return {[type]} [description]
         */
        $scope.bigFace = function() {
            if ($scope.data.item.DOCTYPEID === '2' || $scope.data.item.DOCTYPEID === '7') {
                $scope.status.picsModelShow = !$scope.status.picsModelShow;
            }
            $scope.status.previewBigFace.status = !$scope.status.previewBigFace.status;
        };

        /**
         * [goToEdit description]
         *
         * @return  {[type]}  [return description]
         */
        $scope.goToEdit = function() {
            editingCenterService.routerToEdit('iwo', angular.extend($scope.data.item));
        };

        /**
         * [loadVersionTimePanel 动态加载流程版本信息]
         * @return  {[type]}  [return description]
         */
        function loadVersionTimePanel() {
            var versionPanel =
                '<version-time-panel incoming-data="data.item"></version-time-panel>';
            versionPanel = $compile(versionPanel)($scope);
            $element.find('versionPanel').append(versionPanel);
        }
    },
]);
